export default "__VITE_ASSET__BKuXYtyl__"